<template>
  <div class="popUpWrap dark">
    <section class="popup dark template">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="popupInfo">
          <div class="iconArea">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.70936 20.6961C6.96128 20.832 7.24461 20.8989 7.53068 20.89C7.76861 20.8827 8.01077 20.802 8.4951 20.6405L9.066 20.4502C9.75426 20.2208 10.5021 20.5676 10.7715 21.2412C10.9589 21.7098 11.0527 21.9441 11.1958 22.127C11.4054 22.3946 11.6937 22.5897 12.02 22.6849C12.2429 22.75 12.4953 22.75 13 22.75C13.5047 22.75 13.7571 22.75 13.98 22.6849C14.3063 22.5897 14.5946 22.3946 14.8042 22.127C14.9473 21.9441 15.0411 21.7098 15.2285 21.2412C15.4979 20.5677 16.2457 20.2209 16.934 20.4504L17.5044 20.6406C17.9888 20.802 18.2309 20.8828 18.4689 20.8901C18.7549 20.8989 19.0383 20.8321 19.2902 20.6962C19.4997 20.5833 19.6802 20.4027 20.0412 20.0417C20.4022 19.6808 20.5827 19.5002 20.6957 19.2907C20.8315 19.0388 20.8984 18.7555 20.8896 18.4694C20.8822 18.2315 20.8015 17.9893 20.6401 17.505L20.4071 16.8062C20.2017 16.1897 20.5123 15.52 21.1156 15.2788C21.7057 15.0427 22.0008 14.9247 22.2178 14.7275C22.4096 14.5532 22.5569 14.3356 22.6475 14.0928C22.75 13.8181 22.75 13.4971 22.75 12.8551C22.75 12.313 22.75 12.0419 22.673 11.8007C22.6048 11.5873 22.4933 11.3903 22.3453 11.222C22.1782 11.0319 21.948 10.8938 21.4877 10.6176L21.1867 10.437C20.5268 10.0411 20.2518 9.22474 20.5376 8.51021C20.7201 8.05396 20.8113 7.82581 20.8347 7.60005C20.8689 7.26837 20.8003 6.93416 20.6382 6.6428C20.5278 6.44448 20.3541 6.27074 20.0066 5.92326C19.6797 5.59633 19.5162 5.43285 19.3295 5.32548C19.0552 5.16776 18.7408 5.09355 18.4249 5.11195C18.2099 5.12448 17.9906 5.19758 17.552 5.34379L16.934 5.54978C16.2457 5.7792 15.4979 5.43237 15.2285 4.75877C15.0411 4.29017 14.9473 4.05587 14.8042 3.87303C14.5946 3.60542 14.3063 3.41027 13.98 3.31505C13.7571 3.25 13.5047 3.25 13 3.25C12.4953 3.25 12.2429 3.25 12.02 3.31505C11.6937 3.41027 11.4054 3.60542 11.1958 3.87303C11.0527 4.05586 10.9589 4.29017 10.7715 4.75876C10.502 5.43238 9.75426 5.77926 9.06596 5.54992L8.4476 5.34388C8.00897 5.19767 7.78965 5.12456 7.57463 5.11203C7.25876 5.09363 6.94439 5.16784 6.67009 5.32556C6.48337 5.43293 6.3199 5.5964 5.99297 5.92333C5.64548 6.27082 5.47174 6.44456 5.36137 6.64288C5.19921 6.93425 5.13061 7.26845 5.16489 7.60013C5.18821 7.8259 5.27947 8.05403 5.46197 8.51029C5.74779 9.22483 5.47282 10.0412 4.81295 10.4372L4.51231 10.6176C4.052 10.8938 3.82185 11.0319 3.65467 11.222C3.50673 11.3903 3.39518 11.5873 3.32702 11.8007C3.25 12.0419 3.25 12.313 3.25 12.8551C3.25 13.4971 3.25 13.8181 3.35251 14.0928C3.44308 14.3356 3.5904 14.5532 3.78217 14.7275C3.99921 14.9247 4.29428 15.0427 4.88438 15.2788C5.48745 15.52 5.79796 16.1895 5.59256 16.8057L5.35948 17.5049C5.19804 17.9892 5.11731 18.2314 5.10997 18.4693C5.10114 18.7554 5.16803 19.0387 5.30386 19.2906C5.41683 19.5002 5.59734 19.6807 5.95833 20.0417C6.31933 20.4027 6.49983 20.5832 6.70936 20.6961ZM13.5204 4.88146C13.5219 4.88445 13.5233 4.88761 13.5249 4.89094C13.5675 4.98308 13.6198 5.11251 13.7197 5.36228C14.3087 6.83474 15.9434 7.59289 17.4479 7.09139L18.0658 6.88541C18.2999 6.80738 18.4204 6.7677 18.5093 6.74289C18.5123 6.74204 18.5152 6.74124 18.518 6.74049C18.5201 6.74239 18.5223 6.7444 18.5247 6.74653C18.5931 6.80847 18.6831 6.89784 18.8575 7.07231C19.0428 7.25758 19.1383 7.35381 19.2044 7.42706C19.2067 7.42967 19.209 7.43215 19.2111 7.43452C19.2101 7.43752 19.209 7.44068 19.2079 7.44401C19.176 7.53735 19.1261 7.66343 19.0288 7.9067C18.4468 9.36176 19.0068 11.0241 20.3506 11.8304L20.6516 12.011C20.8976 12.1586 21.0227 12.2344 21.1103 12.2942C21.1128 12.2959 21.1152 12.2976 21.1175 12.2992C21.1177 12.3024 21.1179 12.3058 21.1181 12.3093C21.1244 12.4171 21.125 12.5658 21.125 12.8551C21.125 13.197 21.1242 13.3758 21.1157 13.505C21.1154 13.5096 21.1151 13.514 21.1148 13.5181C21.1116 13.5197 21.1082 13.5213 21.1046 13.523C20.9897 13.5781 20.8267 13.6441 20.5122 13.7699M13.5204 4.88146C13.5172 4.88126 13.5137 4.88107 13.51 4.88087C13.4086 4.87552 13.269 4.875 13 4.875C12.731 4.875 12.5914 4.87552 12.49 4.88087C12.4863 4.88107 12.4828 4.88126 12.4795 4.88146C12.4781 4.88445 12.4767 4.88761 12.4751 4.89094C12.4325 4.98309 12.3802 5.11252 12.2803 5.36229C11.6913 6.8347 10.0568 7.5929 8.55226 7.09158L7.93373 6.88549C7.69966 6.80746 7.57918 6.76779 7.4903 6.74297C7.48725 6.74212 7.48435 6.74132 7.4816 6.74057C7.47947 6.74247 7.47724 6.74448 7.4749 6.74661C7.40649 6.80855 7.31648 6.89792 7.14201 7.07239C6.95674 7.25766 6.86121 7.35389 6.79518 7.42714C6.79282 7.42975 6.7906 7.43224 6.78849 7.4346C6.7895 7.4376 6.79056 7.44076 6.7917 7.44409C6.82354 7.53742 6.87343 7.6635 6.97075 7.90678C7.55276 9.36181 6.99284 11.0241 5.64914 11.8305L5.3485 12.011C5.10259 12.1585 4.97735 12.2344 4.88968 12.2942C4.88718 12.2959 4.88479 12.2976 4.88251 12.2992C4.88231 12.3024 4.8821 12.3058 4.88189 12.3093C4.87563 12.4171 4.875 12.5658 4.875 12.8551C4.875 13.197 4.87581 13.3758 4.88431 13.505C4.88461 13.5096 4.88491 13.514 4.88522 13.5181C4.88845 13.5197 4.89184 13.5213 4.89539 13.523C5.01031 13.5781 5.17331 13.6441 5.4879 13.77C6.88982 14.3307 7.61165 15.8871 7.13417 17.3195L6.90109 18.0188C6.81493 18.2772 6.77116 18.4103 6.7443 18.5085C6.74342 18.5117 6.74259 18.5147 6.74182 18.5176C6.74381 18.5199 6.74592 18.5223 6.74814 18.5247C6.81607 18.6005 6.91473 18.7 7.10738 18.8926C7.30003 19.0853 7.39948 19.1839 7.47527 19.2519C7.47775 19.2541 7.48011 19.2562 7.48236 19.2582C7.48527 19.2574 7.48832 19.2566 7.49152 19.2557C7.5897 19.2288 7.72276 19.1851 7.98124 19.0989L8.55213 18.9086C10.0566 18.4071 11.6913 19.1653 12.2803 20.6377C12.3802 20.8875 12.4325 21.0169 12.4751 21.1091C12.4767 21.1124 12.4781 21.1156 12.4795 21.1185C12.4828 21.1187 12.4863 21.1189 12.49 21.1191C12.5914 21.1245 12.731 21.125 13 21.125C13.269 21.125 13.4086 21.1245 13.51 21.1191C13.5137 21.1189 13.5172 21.1187 13.5205 21.1185C13.5219 21.1156 13.5233 21.1124 13.5249 21.1091C13.5675 21.0169 13.6198 20.8875 13.7197 20.6377C14.3087 19.1652 15.9435 18.4071 17.448 18.9088L18.0185 19.0991C18.2768 19.1852 18.4099 19.2289 18.508 19.2558C18.5112 19.2567 18.5143 19.2575 18.5172 19.2583C18.5194 19.2563 18.5218 19.2542 18.5243 19.2519C18.6001 19.184 18.6995 19.0853 18.8922 18.8927C19.0848 18.7001 19.1835 18.6006 19.2514 18.5248C19.2536 18.5223 19.2557 18.52 19.2577 18.5177C19.257 18.5148 19.2561 18.5118 19.2553 18.5085C19.2284 18.4104 19.1846 18.2773 19.0985 18.0188L18.8655 17.32C18.388 15.8874 19.1101 14.3307 20.5122 13.7699" fill="#FAFBFF"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13 14.9861C14.0969 14.9861 14.9861 14.0969 14.9861 13C14.9861 11.9031 14.0969 11.0139 13 11.0139C11.9031 11.0139 11.0139 11.9031 11.0139 13C11.0139 14.0969 11.9031 14.9861 13 14.9861ZM13 16.6111C14.9944 16.6111 16.6111 14.9944 16.6111 13C16.6111 11.0056 14.9944 9.38889 13 9.38889C11.0056 9.38889 9.38889 11.0056 9.38889 13C9.38889 14.9944 11.0056 16.6111 13 16.6111Z" fill="#FAFBFF"/>
              </svg>
            </div>
          </div>
          <div class="listTopArea">
            <div class="titleArea">
              <h5>{{ isManageType ? t('skillCertify-template-management') : t('skillCertify-load-template') }}
                <span class="bar">{{ templatePageData.totalElementCount }}</span>
              </h5>
            </div>
            <LazyGlobalSearch
                :key="searchKeyIndex"
                v-model:search-box-flag="searchBoxFlag"
                class="rightArea"
                :placeholder="t('skillCertify-search-template-name-placeholder')"
                :is-page-search="false"
                @set-search-data="onSearch"
            />
          </div>
          <div class="tableType1">
            <div class="tableInfo">
              <ul class="title">
                <li>#</li>
                <li>{{ t('skillCertify-template') }}</li>
                <li>{{ t('skillMonitor-track-info') }}</li>
                <li>{{ isManageType ? t('common-delete') : t('skillCertify-select') }}
                </li>
              </ul>
              <template v-if="!isTemplateLoading">
                <template v-if="templatePageData.data.length > 0">
                  <ul v-for="(template, index) in templatePageData.data" :key="index">
                    <li>{{ getTableIndex(index) }}</li>
                    <li>
                      <div class="labelArea flex">
                        <div class="label set">{{ t('skillCertify-template') }}</div>
                      </div>
                      <div class="titleArea">
                        <h5>{{ template.title }}</h5>
                        <button
                            v-if="isManageType"
                            type="button"
                            class="btn btnCircleIcon"
                            @click.stop="openEditTemplate(template.id, template.title)"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                               fill="none">
                            <path
                                d="M12.5294 4.27263C13.5766 3.28145 15.2322 3.29739 16.2599 4.32048C17.3044 5.3605 17.3044 7.04706 16.2599 8.08708L10.7101 13.6115C10.0504 14.2683 9.65355 14.6645 9.22275 14.9777L9.13682 15.0402C8.75791 15.3029 8.35031 15.5221 7.92295 15.6955L7.83799 15.7297C7.37532 15.9095 6.88629 16.0159 6.11728 16.1681L4.7042 16.4455C4.49541 16.4865 4.27965 16.4196 4.13193 16.2668C3.98423 16.1139 3.92507 15.8963 3.97373 15.6896L4.24228 14.5519L4.38779 13.9396C4.52148 13.389 4.6286 13.004 4.7833 12.6369L4.8165 12.5578C4.98982 12.162 5.20444 11.7845 5.45615 11.4328L5.51475 11.3527C5.81398 10.9527 6.18856 10.5834 6.80674 9.96794V9.96697L12.4806 4.32048L12.5294 4.27263ZM7.6915 10.8527V10.8517C7.04657 11.4938 6.74867 11.7928 6.5206 12.0978L6.47568 12.1593C6.28797 12.4217 6.12654 12.7021 5.99326 12.9953L5.9376 13.1213C5.82025 13.3998 5.73708 13.6963 5.6085 14.2248L5.46201 14.8381L5.41611 15.0314L5.52744 15.0099L5.88291 14.9396C6.65415 14.7864 7.03161 14.7021 7.38291 14.5656L7.45127 14.5383C7.79288 14.3997 8.11818 14.2237 8.421 14.0138L8.4874 13.967C8.81609 13.7281 9.13685 13.4122 9.82529 12.7267L13.5519 9.01775L11.5489 7.01482L7.6915 10.8527ZM15.3751 5.20525C14.8377 4.67023 13.9758 4.65294 13.4181 5.15447L13.3653 5.20525L12.4347 6.13298L14.4376 8.13591L15.3751 7.20232C15.929 6.6507 15.9289 5.75689 15.3751 5.20525Z"
                                fill="#7897D1" />
                          </svg>
                        </button>
                      </div>
                      <ul class="cellSummary">
                        <li>
                          <span>{{ t('skillCertify-constructor') }}</span>
                          <p>{{ hasDeleteMember(template.userStatus) ? t('common-delete-member') : template.name }}</p>
                        </li>
                        <li>
                          <span>{{ t('skillCertify-creation-date') }}</span>
                          <p>{{ getCreateAt(template.createdAt) }}</p>
                        </li>
                      </ul>
                    </li>
                    <LazyProSkillAssureSettingsListContentTableSets
                        v-if="template.assessmentSetInfoVOList.length > 0"
                        :assessment="getAssessmentSets(template.assessmentSetInfoVOList)"
                    />
                    <li>
                      <button
                          v-if="isManageType"
                          type="button"
                          class="btn btnCircleIcon red"
                          @click.stop="openDeleteTemplate(template.id)"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                              d="M9.66211 1.20801C10.6151 1.28425 11.4407 1.92231 11.7471 2.84082L12.0664 3.7998H13.6006V3.80078H14.3994L14.5205 3.8125C14.7939 3.86843 15 4.11043 15 4.40039C14.9999 4.69029 14.7939 4.93236 14.5205 4.98828L14.3994 5H13.5137L12.9619 12.5742L12.9346 12.8057C12.7401 13.946 11.7475 14.7996 10.5684 14.7998H5.43262L5.19922 14.7891C4.12427 14.6853 3.24799 13.8702 3.06641 12.8057L3.03809 12.5742L2.4873 5H1.59961C1.26847 4.99979 1.00008 4.73156 1 4.40039C1 4.06915 1.26842 3.80099 1.59961 3.80078H2.40039V3.7998H3.93262L4.25293 2.84082C4.55924 1.92253 5.38423 1.28446 6.33691 1.20801L6.5293 1.2002H9.46973L9.66211 1.20801ZM4.23535 12.4873L4.24902 12.6025C4.3462 13.1729 4.84288 13.5996 5.43262 13.5996H10.5684C11.197 13.5994 11.7198 13.1143 11.7656 12.4873L12.3096 5H3.69141L4.23535 12.4873ZM6.40039 7C6.73138 7.00022 6.99968 7.26865 7 7.59961V10.7998C6.99989 11.1309 6.73151 11.3992 6.40039 11.3994C6.06909 11.3994 5.80089 11.1311 5.80078 10.7998V7.59961C5.8011 7.26851 6.06922 7 6.40039 7ZM9.60059 7C9.93148 7.00033 10.1999 7.26871 10.2002 7.59961V10.7998C10.2001 11.1309 9.93161 11.3991 9.60059 11.3994C9.26928 11.3994 9.00108 11.1311 9.00098 10.7998V7.59961C9.00129 7.26851 9.26941 7 9.60059 7ZM6.5293 2.40039C6.013 2.40061 5.55391 2.73086 5.39062 3.2207L5.26367 3.60059H10.7354L10.6084 3.2207C10.445 2.73078 9.98619 2.40039 9.46973 2.40039H6.5293Z"
                              fill="#B83737" />
                        </svg>
                      </button>
                      <label v-else :for="`template-${template.id}`">
                        <input
                            :id="`template-${template.id}`"
                            type="radio"
                            :value="template.id"
                            :checked="template.id === selectedTemplateIdMap[pageNumber]"
                            @change="onChangeTemplateId(template.id)"
                        />
                      </label>
                    </li>
                  </ul>
                </template>
                <div v-else class="listNone">
                  {{ searchTitle !== undefined ? t('common-none-search-data') : t('skillCertify-template-none-save-data') }}
                </div>
              </template>
              <div v-else class="loadingImage" />
            </div>
            <LazyPagination
                v-if="templatePageData.data.length > 0 && !isTemplateLoading"
                :pageable="templatePageData"
                :item-size="3"
                :page-size="5"
                @on-click-page-button="onChangePage"
            />
            <div v-if="templateManageType === ProSkillAssureTemplateManageType.LOAD" class="btnArea">
              <button
                  type="button"
                  :class="{disabled: isDisabledApplyButton}"
                  :disabled="isDisabledApplyButton"
                  @click.stop="onApplyTemplate"
              >
                {{ t('common-apply') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <LazyProSkillAssureTemplateRemove
        v-if="removeTemplateId"
        :remove-template-id="removeTemplateId"
        @close="closeDeleteTemplate"
    />
    <LazyProSkillAssureTemplateModify
        v-if="modifyTemplateId"
        :modify-template-id="modifyTemplateId"
        :modify-template-name="modifyTemplateName"
        @close="closeModifyTemplate"
    />
  </div>
</template>

<script setup lang="ts">
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import { useProSkillAssureService } from "~/composables/service/useProSkillAssureService";
import type {
  ProSkillAssureTemplateModel
} from "~~/package/mapper/proSkillAssure/model/template/ProSkillAssureTemplateModel";
import { useNuxtApp } from "#app";
import { PageModel } from "~~/package/mapper/common/model/PageModel";
import { computed, convertTimeToLocalFormatString, getTimeZoneDateString } from "#imports";
import {
  ProSkillAssureAssessmentDataModel
} from "~~/package/mapper/proSkillAssure/model/ProSkillAssureAssessmentDataModel";
import { ProSkillManagerSetModel } from "~~/package/mapper/proSkillManager/model/ProSkillManagerSetModel";
import {
  ProSkillAssureTemplateSetInfoModel
} from "~~/package/mapper/proSkillAssure/model/template/ProSkillAssureTemplateSetInfoModel";
import DialogType from "~/components/Common/Dialog/model/DialogType";
import { UserStatusType } from "~~/package/mapper/user/model/UserStatusType";
import {
  ProSkillAssureTemplateManageType
} from "~~/package/mapper/proSkillAssure/model/template/ProSkillAssureTemplateManageType";
import { loadBuffer } from "cheerio";

const {t} = useI18n()
const {$i18n} = useNuxtApp();

const dialogStore = useDialogStore();
const proSkillAssureService = useProSkillAssureService();

const searchBoxFlag = ref(false);
const isTemplateLoading = ref(true);
const templatePageData = ref<PageModel<ProSkillAssureTemplateModel>>(new PageModel());
const searchTitle = ref<string | undefined>(undefined);
const pageNumber = ref(1);
const templateManageType = ref<ProSkillAssureTemplateManageType>(ProSkillAssureTemplateManageType.MANAGE);
const selectedTemplateIdMap = ref<Record<number, number | null>>({});

const lang = computed(() => $i18n.locale.value.toUpperCase());
const isManageType = computed(() => templateManageType.value === ProSkillAssureTemplateManageType.MANAGE);
const sanitizedSearchTitle = computed(() => searchTitle.value?.trim() ? searchTitle.value : undefined);
const isDisabledApplyButton = computed(() => selectedTemplateIdMap.value[pageNumber.value] == null);
const selectedTemplateId = computed({
  get: () => selectedTemplateIdMap.value[pageNumber.value] ?? null,
  set: (val: number | null) => {
    selectedTemplateIdMap.value[pageNumber.value] = val;
  }
});

const removeTemplateId = ref<number | null>(null);
const modifyTemplateId = ref<number | null>(null);
const modifyTemplateName = ref<string | null>(null);
const searchKeyIndex = ref(0);

const getTableIndex = (index: number) => {
  return (pageNumber.value - 1) * 3 + (index + 1);
}

const hasDeleteMember = (userStatus: UserStatusType) => {
  return userStatus === UserStatusType.LEAVE;
};

const getCreateAt = (created: string) => {
  const createdAt = getTimeZoneDateString(created);
  return convertTimeToLocalFormatString(createdAt, $i18n.locale.value)
}

const getAssessmentSets = (list: ProSkillAssureTemplateSetInfoModel[]) => {
  return {
    ...new ProSkillAssureAssessmentDataModel(),
    sets: list.map((set) => new ProSkillManagerSetModel(
        set.trackId,
        set.trackTitle,
        set.trackLevelTitle,
        0,
        set.taskCount,
        set.assessmentContentType
    ))
  }
};

const getTemplateList = (page: number, title?: string) => {
  proSkillAssureService.getProSkillAssureTemplate(page, 3, lang.value, title).then(pageData => {
    templatePageData.value = pageData;

    const selectedId = selectedTemplateIdMap.value[page] ?? null;
    if (selectedId) {
      selectedTemplateIdMap.value[page] = selectedId;
    }

    isTemplateLoading.value = false;
  })
}

const onChangeTemplateId = (templateId: number) => {
  selectedTemplateIdMap.value[pageNumber.value] = templateId;

}
const onChangePage = (page: number) => {
  pageNumber.value = page;
  isTemplateLoading.value = true;
  getTemplateList(page, sanitizedSearchTitle.value);
}

const onSearch = (keyword: string) => {
  selectedTemplateId.value = null
  pageNumber.value = 1
  isTemplateLoading.value = true;
  searchTitle.value = keyword;
  getTemplateList(pageNumber.value, sanitizedSearchTitle.value);
}

const onApplyTemplate = () => {
  if (isDisabledApplyButton.value) return;
  dialogStore.options.props.callBack(
    templatePageData.value.data.find(item => item.id === selectedTemplateIdMap.value[pageNumber.value]),
    selectedTemplateId.value,
    pageNumber.value
  );
}

const onClearSearchTitle = () => {
  searchKeyIndex.value += 1;
  searchTitle.value = "";
  onSearch(undefined);
}

const openEditTemplate = (templateId: number, templateTitle: string) => {
  modifyTemplateId.value = templateId;
  modifyTemplateName.value = templateTitle;
}

const closeModifyTemplate = (isModify: boolean) => {
  modifyTemplateId.value = null;
  modifyTemplateName.value = null;
  if(isModify) onClearSearchTitle();
}

const openDeleteTemplate = (templateId: number) => {
  removeTemplateId.value = templateId;
}

const closeDeleteTemplate = (isRemove: boolean) => {
  removeTemplateId.value = null;
  if(isRemove) onClearSearchTitle();
}

const onClickClose = () => {
  dialogStore.close();
};

onMounted(() => {
  templateManageType.value = dialogStore.options.props.manageType;
  if(dialogStore.options.props.selectTemplateId > 0)
    selectedTemplateIdMap.value[dialogStore.options.props.pageNumber] = dialogStore.options.props.selectTemplateId;
  if(dialogStore.options.props.pageNumber > 0)
    pageNumber.value = dialogStore.options.props.pageNumber;
  getTemplateList(pageNumber.value);
})
</script>

